// extracted by mini-css-extract-plugin
export default {"link":"Nav_link__52QK3","nav":"Nav_nav__IyL11"};